import api from '../baseApi.js'
import { unwrap } from '../helpers.js'

export const attendanceApi = {
  getByClass: (classId, date) =>
    api.get(`/attendance/class/${classId}`, { params: date ? { date } : {} }).then(unwrap),
  getByStudent: (studentId) =>
    api.get(`/attendance/student/${studentId}`).then(unwrap),
  save: (data) => api.post('/attendance', data).then(unwrap),
  saveBulk: (data) => api.post('/attendance/mark-bulk', data).then(unwrap),
}
